import { createSelector } from 'reselect';

import { MACHINE_STATUSES } from 'lib/constants';
import { getDowntimeIntervals } from 'lib/selectors/getDowntimeIntervals';
import { getStatusLabel } from 'lib/selectors/getStatusLabel';
import { getUnavailableStartAt } from 'lib/selectors/getUnavailableStartAt';

const { ACTIVE } = MACHINE_STATUSES;

const getActiveUncategorizedInterval = createSelector(
  [getStatusLabel, getDowntimeIntervals, getUnavailableStartAt],
  (status, downtimes, unavailableStartAt) => {
    if (status === ACTIVE || unavailableStartAt) return null;

    const interval = downtimes.filter((downtime) => {
      return !downtime.end && !downtime.categorized;
    })[0];

    return interval || null;
  }
);

export { getActiveUncategorizedInterval };
